<div [formGroup]="this.formGroup">
    <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>{{field.label}}</mat-label>
        <input (blur)="onBlurEvent($event)" matInput placeholder="{{field.label}}" [formControlName]="this.fieldKey">
        <!--<mat-hint>Hint</mat-hint>-->
    </mat-form-field>
</div>